<template>
    <div class="echart-line"  ref="echartsBarRef" style="height: 400px; width: 100%"></div>
</template>

<script>
import * as echarts from 'echarts';
import macarons from  '@/apis/macarons'
export default {
    name: 'EchartLine',
    props : {
        search : Object
    },
    components: {

    },
    data () {
        return {
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['2025-02','2025-03','2025-04', '2025-05', '2025-06', '2025-07', '2025-08','2025-09', '2025-10', '2025-11', '2025-12', '2026-01'],
                        axisLabel: {
                            rotate: 30 // 旋转45度
                        },
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '项目金额',
                        type: 'bar',
                        barWidth: 30,
                        data: [10, 390, 52, 200, 334, 390, 330, 220,200, 390, 330, 220]
                    }
                ]
            }
        }
    },
    created(){

    },
    mounted(){
        this.$nextTick(() => {
            this.GetLineEchart();
        })
    },
    methods:{
        GetLineEchart(){
            console.log(this.search)
            const chartDom = this.$refs.echartsBarRef;
            echarts.registerTheme('macarons', macarons);
            const myChart = echarts.init(chartDom, macarons);
            myChart.setOption(this.option);
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
